import React, { useState } from 'react';
import { Button, IconButton, Tooltip, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function SearchButton({ onClick, large = false, tooltip, disabled = false }) {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        if (disabled || loading) return;
        setLoading(true);
        try {
            await onClick?.();
        } finally {
            setLoading(false);
        }
    };

    if (large) {
        return (
            <Tooltip title={tooltip || 'Search'}>
                <span>
                    <Button
                        variant="text"
                        onClick={handleClick}
                        disabled={disabled || loading}
                        startIcon={loading ? <CircularProgress size={20} /> : <SearchIcon />}
                    >
                        Search
                    </Button>
                </span>
            </Tooltip>
        );
    }

    return (
        <Tooltip title={tooltip || 'Search'}>
            <span>
                <IconButton
                    type="button"
                    onClick={handleClick}
                    disabled={disabled || loading}
                >
                    {loading ? <CircularProgress size={20} /> : <SearchIcon />}
                </IconButton>
            </span>
        </Tooltip>
    );
}
